export default function MyTeamTHead() {
    return (
        <thead className="sticky top-0 z-10 bg-[#eef6fc]">
            <tr className="border-b border-[#186cb2]/15">
                <th className="px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-[#186cb2]">
                    Name
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-[#186cb2]">
                    Location
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-[#186cb2]">
                    Email
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-[#186cb2]">
                    Contact Number
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-[#186cb2]">
                    Status
                </th>
                <th className="px-3 py-2 text-center text-[10px] font-semibold uppercase tracking-wide text-[#186cb2]">
                    Action
                </th>
            </tr>
        </thead>
    )
}
